import { useCallback, useMemo, useState } from 'react';

import { applyColumnFilters } from './utils';

const useTableFilter = () => {
  const [columnFilters, setColumnFilters] = useState({});

  const onColumnFiltersChange = useCallback((columnKey, filterState) => {
    setColumnFilters(prev => ({ ...prev, [columnKey]: filterState }));
  }, []);

  const applyFilters = useCallback(
    (data, config) => applyColumnFilters(data, columnFilters, config),
    [columnFilters],
  );

  const resetFilters = useCallback(() => {
    setColumnFilters({});
  }, []);

  return useMemo(
    () => ({
      columnFilters,
      onColumnFiltersChange,
      applyFilters,
      resetFilters,
    }),
    [columnFilters, onColumnFiltersChange, applyFilters, resetFilters],
  );
};

export default useTableFilter;
